// src/utils/useFrameMeasurements.js
import { useContext, useMemo } from "react";
import { ControlContext } from "../ControlContext.jsx";
import { computeFrameMeasurements } from "./frameMeasurements.js";

/** Read the measurement stack straight off ControlContext. */
export function useFrameMeasurements() {
  const {
    showMeasurements,
    measurementsPosition,
    measurementsOrientation,
    totalWidthLabelPosition,
    totalHeightLabelPosition,
    printWidth,
    printHeight,
    borderWidth,
    borderHeight,
    borderOffsetX,
    borderOffsetY,
    frameType,
    boxProfileWidth,
    boxProfileDepth,
    floatProfileWidth,
    floatProfileDepth,
    aluminumProfileWidth,
    aluminumProfileDepth,
  } = useContext(ControlContext);

  return useMemo(
    () => ({
      showMeasurements,
      ...computeFrameMeasurements({
        measurementsPosition,
        measurementsOrientation,
        totalWidthLabelPosition,
        totalHeightLabelPosition,
        printWidth,
        printHeight,
        borderWidth,
        borderHeight,
        borderOffsetX,
        borderOffsetY,
        frameType,
        boxProfileWidth,
        boxProfileDepth,
        floatProfileWidth,
        floatProfileDepth,
        aluminumProfileWidth,
        aluminumProfileDepth,
      }),
    }),
    [
      showMeasurements,
      measurementsPosition,
      measurementsOrientation,
      totalWidthLabelPosition,
      totalHeightLabelPosition,
      printWidth,
      printHeight,
      borderWidth,
      borderHeight,
      borderOffsetX,
      borderOffsetY,
      frameType,
      boxProfileWidth,
      boxProfileDepth,
      floatProfileWidth,
      floatProfileDepth,
      aluminumProfileWidth,
      aluminumProfileDepth,
    ],
  );
}
